import { SelectField } from '@eventbrite/eds-input-field';
import { gettext } from '@eventbrite/i18n';
import React, { Component } from 'react';
import { SelectStructure } from '../../../types';
import { OFFICE_DATA } from '../../constants/contactInfoData';
import './SelectOffice.scss';

interface SelectOfficeStructure {
    onChangeOffice: Function;
}
class SelectOffice extends Component<SelectOfficeStructure> {
    _handleOnChangeOffice(value: string) {
        this.props.onChangeOffice(value);
    }
    render() {
        const offices: Array<SelectStructure> = [];
        const displayText = 'Select Location';
        Object.entries(OFFICE_DATA).forEach(([key, value]) => {
            offices.push({ value: key, display: value.name.toString() });
        });

        return (
            <section className="select-office-section eds-align--center">
                <div className="select-office-container">
                    <h2 className="eds-text-hm eds-text-weight--light eds-text-color--white eds-l-mar-top-2 eds-align--center">
                        {gettext('Looking for another office?')}
                    </h2>
                    <div className="eds-l-mar-top-4 eds-align--center">
                        <SelectField
                            style="basic"
                            label={displayText}
                            placeholder={displayText}
                            values={offices}
                            onChange={(value: string) =>
                                this._handleOnChangeOffice(value)
                            }
                        />
                    </div>
                </div>
            </section>
        );
    }
}

export default SelectOffice;
